import { Injectable } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { GeoClustersFrecuencyPlacesAPIService } from "../../shared/services/API/GeoClustersFrecuencyPlacesAPI.service";
import { ChartOptions } from "chart.js";

@Injectable({
  providedIn: "root",
})
export class GeoClustersFrecuencyPlacesService{
  public isLoading: boolean = false;
  public isRecurrentPlacesVisible: boolean = false;
  public identifierRecurrentPlaces: string = "";
  private isRecurrentPlaces$: Subject<boolean> = new Subject<boolean>();

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        max: 24,
        ticks: {
          stepSize: 1
        },
        title: {
          display: true,
          text: 'Hora promedio'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Día de la semana'
        }
      }
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function(context) {
            return `Hora promedio: ${context.parsed.y}`;
          }
        }
      }
    }
  };


  constructor(private geoClustersFrecuencyService: GeoClustersFrecuencyPlacesAPIService) {
  }

  
  setRecurrentPlaces(isRecurrentPlaces: boolean) {
    this.isRecurrentPlacesVisible = isRecurrentPlaces;
    this.isLoading = isRecurrentPlaces;
    if (!isRecurrentPlaces) 
      this.identifierRecurrentPlaces = "";
    this.isRecurrentPlaces$.next(isRecurrentPlaces);
  }
  getRecurrentPlaces() {
    return this.isRecurrentPlaces$.asObservable();
  }

  GetByIdentifier(identifier: string) {
    return this.geoClustersFrecuencyService.GetByIdentifier(identifier);
  }
  
  GetByIdentifierGeoJson(identifier: string) {
    return this.geoClustersFrecuencyService.GetByIdentifierGeoJson(identifier);
  }
}
